import '@src/styles/GlobalStyles.css';

module.exports = require('@uhg-abyss/core/next-app');
